<flx-modal
  [dismissible]="!showLoader()"
  [ngClass]="showLoader() ? 'w-auto' : 'w-[600px]'"
  (dismiss)="cancelImport()"
  class="flex flex-col p-8 relative"
>
  @if (!showLoader()) {
    <h1
      class="text-2xl font-bold text-neutral-900 text-center"
      flxModalHeaderTitle
    >
      Review Resource Identifiers Conflicts
    </h1>
  }
  @if (!showLoader()) {
    <h2
      class="text-sm text-neutral-500 font-normal"
      flxModalHeaderSubtitle
    >
      Select a strategy for the resources that already exist in the destination project.
    </h2>
  }
  @if (!showLoader()) {
    <div class="flex flex-col gap-2 mt-6">
      @if (existingResources.conflicts.length > 1) {
        <div class="flex gap-2">
          @for (option of selectOptions; track option.value) {
            <flx-radio
              [value]="option.value"
              [formControl]="applyToAllFC"
              [checked]="applyToAllFC.value === option.value"
              class="basis-1/3 all-option"
              clear="true"
              attr.data-testid="apply-to-all-radio-{{ option.value }}"
            >
              <flx-label>Apply to all</flx-label>
            </flx-radio>
          }
        </div>
      }
      <div class="flex flex-col gap-4 max-h-[400px] overflow-auto">
        @for (resource of existingResources.conflicts; track resource.resourceName) {
          @let resourceFC = $any(existingResourcesFA.at($index));

          <flx-choice-group class="flex flex-col gap-2">
            <flx-label class="flex items-center gap-1 text-sm font-semibold">
              <span>{{ resource.resourceName }}</span>
            </flx-label>
            <div class="flex w-full gap-2">
              @for (option of selectOptions; track option.value) {
                <flx-radio
                  [value]="option.value"
                  [formControl]="resourceFC"
                  [checked]="resourceFC.value === option.value"
                  [attr.data-testid]="resource.resourceName + '-' + option.value + '-radio-button'"
                  class="basis-1/3"
                >
                  <flx-label class="text-sm">{{ option.label }}</flx-label>
                </flx-radio>
              }
            </div>
          </flx-choice-group>
        }
      </div>
    </div>
    @if (userChoiceSkippAll()) {
      <div
        class="flex items-center gap-2 rounded h-8 px-2 mt-8 text-xs text-neutral-700 bg-yellow-50"
      >
        <flx-icon
          name="warning"
          class="w-4 h-4 text-yellow-500 fill-current"
        ></flx-icon
        >All resources are set to be skipped. If you continue, nothing will be imported.
      </div>
    }
    <div class="flex mt-8 gap-4">
      <button
        (click)="cancelImport()"
        class="grow"
        variant="ghost"
        flxButton
        data-testid="cancel-import-button"
      >
        Cancel
      </button>
      @if (userChoiceSkippAll()) {
        <button
          (click)="cancelImport()"
          class="ml-auto grow"
          flxButton
          data-testid="exit-without-importing-button"
        >
          Exit without importing
        </button>
      } @else {
        <button
          (click)="continueImport()"
          class="ml-auto grow"
          flxButton
          data-testid="continue-import-button"
        >
          Continue
        </button>
      }
    </div>
  }
  @if (showLoader()) {
    <div class="flex items-center justify-center">
      <flx-spinner
        visualType="custom"
        size="small"
        text="Importing resources..."
      />
    </div>
  }
</flx-modal>
